export const SPECIAL_CITIES = ['SOUTH CENTRAL (agg)'];

export const EIA_REGIONS_PREFIX = 'EIA REGIONS';

export const ALL_REGIONS_PREFIX = 'ALL REGIONS';

export const AGGREGATED_SUFFIX = ' (agg)';

export const REGIONS_KEYWORD = 'regions';
